import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, HostBinding, NgModule } from '@angular/core';

class SeFeFormFieldSuffixStylesComponent {
}
SeFeFormFieldSuffixStylesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldSuffixStylesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeFormFieldSuffixStylesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeFormFieldSuffixStylesComponent, selector: "se-fe-form-field-suffix-styles", ngImport: i0, template: '', isInline: true, styles: ["se-fe-form-field-suffix-styles{display:none}.se-fe-form-field-suffix>*:not(.se-fe-form-field-suffix__suffix),.se-fe-form-field-suffix .se-fe-form-field-suffix__input{border-bottom-right-radius:0!important;border-top-right-radius:0!important;flex:1 1 auto;position:relative}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldSuffixStylesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-form-field-suffix-styles',
                    template: '',
                    styleUrls: ['./se-fe-form-field-suffix-styles.component.scss'],
                    encapsulation: ViewEncapsulation.None,
                }]
        }] });

class SeFeFormFieldSuffixComponent {
    constructor(element) {
        this.element = element;
        this.suffix = '';
        this.size = 10;
        this.baseClass = true;
        this.detailsId = `se-fe-form-field-suffix-${Date.now()}-${SeFeFormFieldSuffixComponent.counter++}`;
        this.newChildElements = (changes) => {
            const oldInput = this.input;
            const input = this.input = this.selectInput();
            if (input || input !== oldInput) {
                const describedby = this.input.getAttribute('aria-describedby');
                this.input.classList.add('se-fe-form-field-suffix__input');
                this.input.setAttribute('aria-describedby', `${this.detailsId} ${describedby}`);
            }
        };
        this.observeInput();
    }
    ngOnDestroy() {
        if (this.inputObserver)
            this.inputObserver.disconnect();
    }
    select(selector) {
        return this.element.nativeElement.querySelector(selector);
    }
    // finds the most likely HTML input
    selectInput() {
        return this.select('[seFeFormFieldInput]') || // tagged elements first
            this.select('input:not([type="button"]):not([type="submit"]), select, textarea') || // then common inputs
            this.select('button, input') || // then buttons (less likely to be the primary input)
            undefined;
    }
    observeInput() {
        this.inputObserver = new MutationObserver(this.newChildElements);
        this.inputObserver.observe(this.element.nativeElement, { childList: true, subtree: true });
    }
}
SeFeFormFieldSuffixComponent.counter = 1;
SeFeFormFieldSuffixComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldSuffixComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
SeFeFormFieldSuffixComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeFormFieldSuffixComponent, selector: "se-fe-form-field-suffix", inputs: { suffix: ["seFeDataSuffix", "suffix"], size: ["seFeDataSize", "size"] }, host: { properties: { "class.se-fe-form-field-suffix": "this.baseClass" } }, ngImport: i0, template: "<ng-content></ng-content>\n<span\n  [attr.id]=\"detailsId\"\n  class=\"se-fe-form-field-suffix__suffix\"\n  style=\"min-width:{{size}}em\">\n  <span class=\"se-fe-sr-only\">Current: {{ suffix }}.</span>\n  <span aria-hidden=\"true\">{{ suffix }}</span>\n  <se-fe-form-field-suffix-styles></se-fe-form-field-suffix-styles>\n</span>\n", styles: [".se-fe-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.se-fe-sr-only-focusable:focus{position:relative;width:auto;height:auto;clip:initial;margin:inherit;padding:inherit;border:initial}:host{display:flex;flex-wrap:nowrap;font:var(--se-body-font)}.se-fe-form-field-suffix__suffix{align-items:center;background:var(--se-inactive-bg);border-bottom:1px solid var(--se-border);border-radius:0 4px 4px 0;border-right:1px solid var(--se-border);border-top:1px solid var(--se-border);box-sizing:content-box;color:var(--se-label);display:flex;flex:0 0 auto;justify-content:center;padding:0 var(--se-content-spacing);white-space:nowrap}\n"], components: [{ type: SeFeFormFieldSuffixStylesComponent, selector: "se-fe-form-field-suffix-styles" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldSuffixComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-form-field-suffix',
                    templateUrl: './se-fe-form-field-suffix.component.html',
                    styleUrls: ['./se-fe-form-field-suffix.component.scss'],
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { suffix: [{
                type: Input,
                args: ['seFeDataSuffix']
            }], size: [{
                type: Input,
                args: ['seFeDataSize']
            }], baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-form-field-suffix']
            }] } });

class SeFeFormFieldSuffixModule {
}
SeFeFormFieldSuffixModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldSuffixModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeFormFieldSuffixModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldSuffixModule, declarations: [SeFeFormFieldSuffixComponent, SeFeFormFieldSuffixStylesComponent], imports: [CommonModule], exports: [SeFeFormFieldSuffixComponent] });
SeFeFormFieldSuffixModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldSuffixModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeFormFieldSuffixModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeFormFieldSuffixComponent, SeFeFormFieldSuffixStylesComponent],
                    imports: [CommonModule],
                    exports: [SeFeFormFieldSuffixComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeFormFieldSuffixComponent, SeFeFormFieldSuffixModule };
